import { Hammer } from "lucide-react";
import { Link } from "react-router-dom";

// A feature that isn't finished yet, regardless of subscription plan — distinct
// from components/plan/UpgradePrompt, which is for plan-gated features that
// are otherwise fully built. Route access is blocked here too (not just the
// sidebar link), so a bookmark or guessed URL can't reach a half-built page.
export default function UnderDevelopment({ title, message }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-gray-200 bg-white p-10 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-400">
        <Hammer size={22} aria-hidden="true" />
      </div>
      {title && <h1 className="font-bold text-gray-800">{title}</h1>}
      <p className="max-w-sm text-sm text-gray-500">{message || "این بخش هنوز در حال توسعه است و به‌زودی فعال خواهد شد."}</p>
      <Link to="/dashboard" className="mt-1 rounded-lg bg-secondary px-4 py-2 text-sm font-semibold text-white hover:opacity-90">
        بازگشت به داشبورد
      </Link>
    </div>
  );
}
